module.exports = __webpack_public_path__ + "static/media/LowRisk.3729182c.svg";